import { ConfigFilterItem, ConfigItem } from 'Core/interfaces'

export enum MouSearchResultFields {
	searchBySubject = 'searchBySubject',
	searchByMouNumber = 'searchByMouNumber'
}

export enum MouFilterFields {
	serviceSite = 'ServiceSites',
	issuedDateFrom = 'IssuedDateFrom',
	issuedDateTo = 'IssuedDateTo'
}

export declare namespace Mou {
	interface Basic {
		expirationDate: BasicString
		id: number
		issuedDate: BasicString
		mouNumber: BasicString
		subject: BasicString
	}
	namespace Filter {
		interface Config {
			[MouFilterFields.serviceSite]: ConfigFilterItem<string, string>
			[MouFilterFields.issuedDateFrom]: ConfigFilterItem<string, null>
			[MouFilterFields.issuedDateTo]: ConfigFilterItem<string, null>
		}
	}

	namespace Search {
		interface Config {
			searchByMouNumber: ConfigItem<
				MouSearchResultFields,
				Result['searchByMouNumber'][number]
			>
			searchBySubject: ConfigItem<MouSearchResultFields, Result['searchBySubject'][number]>
		}

		interface Result {
			searchByMouNumber: {
				id: number
				mouNumber: string
				subject: string
			}[]
			searchBySubject: {
				id: number
				mouNumber: string
				subject: string
			}[]
		}
	}
}
